export const get = function () {
  return document.location.pathname.split('/').pop();
};

export const injectInto = function (str) {
  return str.replace(/\$\{groupId\}/g, get());
};
